/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment */

import { NodeData } from '@contentful/rich-text-types';
import { Box } from '@mui/material';
import TAGSvgIcon from '../TAGSvgIcon';
import { checkedIconBoxStyles, xMarkIconBoxStyles } from './Table.styles';

/* Template specific functions,
these are placeholders which are used in contentful in tables */
const placeHolderValues: {
  [key: string]: string;
} = Object.freeze({
  HIGHLIGHTED: ':highlighted:',
  CHECKED: ':checked:',
  XMARK: ':xmark:'
});

/* Helper function to remove placeholders from contentful data */
const removePlaceHolderValues = (str: string) => {
  let text = str;
  for (const key of Object.keys(placeHolderValues)) {
    const code = placeHolderValues[key];
    text = text.replace(code, '');
  }
  return text;
};
const CheckedIcon = () => {
  return <Box sx={checkedIconBoxStyles} data-sentry-element="Box" data-sentry-component="CheckedIcon" data-sentry-source-file="Table.utils.tsx">
			<TAGSvgIcon icon={'Check'} data-sentry-element="TAGSvgIcon" data-sentry-source-file="Table.utils.tsx" />
		</Box>;
};
const CheckedIconDefault = () => {
  return <TAGSvgIcon icon="CheckDefault" width="31" height="20" viewBox="0 0 31 20" data-sentry-element="TAGSvgIcon" data-sentry-component="CheckedIconDefault" data-sentry-source-file="Table.utils.tsx" />;
};
const XMarkIcon = () => {
  return <Box sx={xMarkIconBoxStyles} data-sentry-element="Box" data-sentry-component="XMarkIcon" data-sentry-source-file="Table.utils.tsx">
			<TAGSvgIcon icon={'XmarkDefault'} data-sentry-element="TAGSvgIcon" data-sentry-source-file="Table.utils.tsx" />
		</Box>;
};
const XMarkIconDefault = () => {
  return <Box data-sentry-element="Box" data-sentry-component="XMarkIconDefault" data-sentry-source-file="Table.utils.tsx">
			<TAGSvgIcon icon="XmarkDefault" width="20" height="20" viewBox="0 0 20 20" data-sentry-element="TAGSvgIcon" data-sentry-source-file="Table.utils.tsx" />
		</Box>;
};
const hasPlaceHolders = (elements: NodeData[]): {
  [key: string]: boolean;
} => {
  const placeholders: {
    [key: string]: boolean;
  } = {};
  for (const key in placeHolderValues) {
    if (Object.hasOwn(placeHolderValues, key)) {
      if (elements.some((e: NodeData) => e.value?.includes(placeHolderValues[key]))) {
        placeholders[placeHolderValues[key]] = true;
      }
    }
  }
  return placeholders;
};
const getCompareTableHeader = (elements: NodeData[]) => {
  const titleElem = elements.find((e: NodeData) => e.value?.includes('image*title'));
  const title = titleElem?.value?.replaceAll(':image*title*', '') ?? '';
  return title;
};
export { placeHolderValues, hasPlaceHolders, removePlaceHolderValues, CheckedIcon, CheckedIconDefault, XMarkIcon, XMarkIconDefault, getCompareTableHeader };